
import { AttributeClass } from '../enums';

export const AttributeClasses = [
  { name: 'Tag', value: AttributeClass.Tag, pluralName: 'Tags' },
  { name: 'Time Entry Tag', value: AttributeClass.TimeEntryTag, pluralName: 'Time Entry Tags' },
];


